import { logWrapper } from '../utils';

function limitToDirectiveFactory(runtimeConstant) {
  function link(scope, elem, attrs) {
    const limit = parseInt(attrs.limitTo, 10);

    // Garante que o valor limite seja um número válido
    if (isNaN(limit) || limit <= 0) {
      return;
    }

    // Impede o usuário de digitar além do limite
    angular.element(elem).on('keypress', function (e) {
      if (this.value.length === limit) {
        e.preventDefault();
      }
    });
  }

  function run() {
    return {
      restrict: 'A',
      link,
    };
  }

  return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const limitToDirective = ['runtimeConstant', limitToDirectiveFactory];
